import { Link } from "react-router-dom";
import { Clock, Lock, BookOpen } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import type { Article } from "@/data/launchKitArticles";

interface ArticleCardProps {
  article: Article;
}

export const ArticleCard = ({ article }: ArticleCardProps) => {
  const cardContent = (
    <Card 
      className={cn(
        "h-full transition-all duration-200",
        article.isLocked 
          ? "opacity-50 bg-muted/50" 
          : "hover:shadow-md hover:border-primary/50 cursor-pointer"
      )}
    >
      <CardHeader className="pb-3">
        <div className="flex items-start justify-between gap-2">
          <div className="flex items-center gap-2">
            {article.isLocked ? (
              <Lock className="h-5 w-5 text-muted-foreground" />
            ) : (
              <BookOpen className="h-5 w-5 text-primary" />
            )}
            <CardTitle className="text-lg leading-tight">{article.title}</CardTitle>
          </div>
          {article.isLocked && (
            <Badge variant="secondary" className="shrink-0">
              Premium
            </Badge>
          )}
        </div>
      </CardHeader>
      <CardContent>
        <CardDescription className="mb-3">{article.description}</CardDescription>
        <div className="flex items-center gap-1 text-xs text-muted-foreground">
          <Clock className="h-3 w-3" />
          <span>{article.readTime} read</span>
        </div>
      </CardContent>
    </Card>
  );

  if (article.isLocked) {
    return <div className="cursor-not-allowed">{cardContent}</div>;
  }

  return <Link to={`/app/launch-kit/${article.id}`}>{cardContent}</Link>;
};
